import { Checkbox } from '@altify/components';
import { InfoButton } from 'components/InfoButton/InfoButton';

const IntentCheckbox = ({
  checkboxName,
  checkboxValue,
  tooltip,
  tooltipText,
  onChange,
  checked,
}: {
  checkboxName: string;
  checkboxValue: string;
  tooltip?: boolean;
  tooltipText?: string;
  checked?: boolean;
  onChange: (checked: boolean, value: string) => void;
}) => {
  return (
    <div className="sm:px-3 py-2 flex flex-row">
      <Checkbox
        value={checked}
        onChange={checked => onChange(checked, checkboxValue)}
        label={checkboxName}
      />
      {tooltip && tooltipText && (
        <InfoButton
          className="ml-2"
          tooltipPlacement="bottom"
          title={checkboxName}
          text={tooltipText}
        />
      )}
    </div>
  );
};

export default IntentCheckbox;
